// @flow
import { trackAnalyticsEvent } from '../../lib/analytics';

export type TopUpAvailableActionType = {|
  type: 'SET_AVAILABLE_TOP_UPS',
  payload: {
    topUps: { [string]: Object },
    topUpType: string,
  },
|};

export type TopUpSelectedActionType =
  | {|
      type: 'INIT_TOP_UP',
    |}
  | {|
      type: 'CLEAR_TOP_UP',
    |}
  | {|
      type: 'ADD_TOP_UP_TO_SELECTION',
      payload: {
        newTopUp: Object,
        topUpToRemove: Object,
      },
    |};

export type PermanentTopUpAvailableActionType = {|
  type: 'SET_AVAILABLE_PERMANENT_TOP_UPS',
  payload: {
    topUps: Object,
  },
|};

export type TopUpsAction =
  | {|
      type: 'TOP_UP_USAGES',
    |}
  | {|
      type: 'FETCH_TOP_UPS',
      payload: {
        permanent: boolean,
      },
    |};

export const initTopUp = () => ({
  type: 'INIT_TOP_UP',
});

export const clearTopUp = () => ({
  type: 'CLEAR_TOP_UP',
});

export const setAvailableTopUps = (topUps: { [string]: Object }, topUpType: string) => ({
  type: 'SET_AVAILABLE_TOP_UPS',
  payload: { topUps, topUpType },
});

export const setAvailablePermanentTopUps = (topUps: Object) => ({
  type: 'SET_AVAILABLE_PERMANENT_TOP_UPS',
  payload: { topUps },
});

export const fetchAvailableTopUps = (topUpType: string) => ({
  type: 'FETCH_TOP_UPS',
  payload: {
    topUpType,
    permanent: false,
  },
});

export const fetchAvailablePermanentTopUps = () => ({
  type: 'FETCH_TOP_UPS',
  payload: {
    permanent: true,
  },
});

export function addTopUpToSelection(newTopUp: Object, topUpToRemove?: Object) {
  return {
    type: 'ADD_TOP_UP_TO_SELECTION',
    payload: {
      newTopUp,
      topUpToRemove,
    },
  };
}

export const topUpUsages = () => ({
  type: 'TOP_UP_USAGES',
});

export const topUp = () => {
  trackAnalyticsEvent('top_up');
  return topUpUsages();
};

export const purchaseExtra = () => {
  trackAnalyticsEvent('purchase_extra');
  return topUpUsages();
};
